import React, { useEffect } from "react";
import { Stack, Typography } from "@mui/material";
import { Trans } from "react-i18next";
import { prefixClassName } from "@smartrr/shared/components/primitives";
import { OrderVariantImage } from "../../../../../Subscription/constants";
import { typedLocalize, typedLocalizeKey } from "@smartrr/shared/utils/sharedTranslations/localize";
import { RedeemVariantOTPProps } from "../RedeemVariantOTP";
import { IPurchaseState } from "@smartrr/shared/entities/PurchaseState";
import { LoyaltyStoreAccess } from "../../../../store";
import { RedeemVariantUnpauseDescription } from "./RedeemVariantUnpauseDescription";
import { RedeemVariantUnpauseButtons } from "./RedeemVariantUnpauseButtons";
import { DeliveryAccess } from "@customer-app/state/stores/delivery";
import { ModalState } from "../../../../utils/constants";

export interface RedeemVariantUnpauseProps extends RedeemVariantOTPProps {
  purchaseState: IPurchaseState;
  purchasableName: string;
}

export const RedeemVariantUnpause = ({
  variant,
  purchasableName,
  shopifyVariant,
  closeVariantModal,
  purchaseState,
}: RedeemVariantUnpauseProps) => {
  const actions = LoyaltyStoreAccess.useActions();
  const pausedDeliveries = DeliveryAccess.usePausedDeliveries();
  const upcomingPausedDelivery = pausedDeliveries.find(
    delivery => delivery.purchaseState.id === purchaseState.id
  );

  useEffect(() => {
    if (upcomingPausedDelivery) {
      actions.order.updateUpcomingPaused(upcomingPausedDelivery);
    }

    actions.modal.updateModalState(ModalState.INITIAL_REDEMPTION);
  }, [upcomingPausedDelivery]);

  if (purchaseState?.unpauseDate) {
    return (
      <React.Fragment>
        <Stack alignItems="center" justifyContent="center" py="30px" spacing="10px">
          <Typography variant="h4">
            <Trans
              i18nKey={typedLocalizeKey("loyalty.redeemUnpause")}
              components={[<span key={0} />, <span key={1} />]}
              values={{
                productName: purchasableName,
              }}
            />
          </Typography>
          <OrderVariantImage
            purchasableVariant={shopifyVariant}
            size="medium"
            className={prefixClassName("item-variant-image")}
          />
          <RedeemVariantUnpauseDescription
            purchasableName={purchasableName}
            unpauseDate={purchaseState.unpauseDate}
          />
        </Stack>
        <RedeemVariantUnpauseButtons
          purchaseState={purchaseState}
          closeVariantModal={closeVariantModal}
          variant={variant}
          purchasableName={purchasableName}
        />
      </React.Fragment>
    );
  }

  return (
    <React.Fragment>
      <Stack alignItems="center" justifyContent="center" py="30px" spacing="10px">
        <Typography variant="h4">
          <Trans
            i18nKey={typedLocalizeKey("loyalty.redeemUnpause")}
            components={[<span key={0} />, <span key={1} />]}
            values={{
              productName: purchasableName,
            }}
          />
        </Typography>
        <OrderVariantImage
          purchasableVariant={shopifyVariant}
          size="medium"
          className={prefixClassName("item-variant-image")}
        />
        <Typography variant="body1" textAlign="center">
          {typedLocalize("loyalty.redeemNoUnpauseDate")}
        </Typography>
      </Stack>
      <RedeemVariantUnpauseButtons
        purchaseState={purchaseState}
        closeVariantModal={closeVariantModal}
        variant={variant}
        purchasableName={purchasableName}
      />
    </React.Fragment>
  );
};
